import { useEffect, useState } from 'react';
import fetchCountries from '@afosto/utils/fetchCountries';

export default () => {
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    let isMounted = true;

    /**
     * fetch the countries from local file.
     * @returns {Promise<never>}
     */
    const handleFetchCountries = async () => {
      try {
        const response = await fetchCountries();

        if (isMounted) {
          setCountries(response);
        }
      } catch (error) {
        if (isMounted) {
          setCountries([]);
        }
      }
    };

    handleFetchCountries();

    return () => {
      isMounted = false;
    };
  }, []);

  return countries;
};
